import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, ScrollRestoration } from "react-router-dom";
import AuthLoader from "../components/loader/authLoader";
import LoadingModal from "../components/loader/loadingModal";
import { isOAuthReturnUrl } from "../helpers/exchangeOAuth";
import { isOAuthBootstrapInFlight } from "../helpers/exchangeOAuthBootstrap";
import {
  setLoading,
  setResponseLoading,
  setSettingUpService,
  setSigningYouIn,
} from "../redux/loading/loadingSlice";

export const LoginLayout = () => {
  const dispatch = useDispatch();
  const isOAuthCallback = isOAuthReturnUrl();
  const oauthBootstrapActive =
    isOAuthCallback && isOAuthBootstrapInFlight();

  const loaders = useSelector((state) => state?.loader);
  const userState = useSelector((state) => state.user);
  const persistedUser = userState?.user;

  useEffect(() => {
    if (isOAuthCallback) {
      dispatch(setSigningYouIn(false));
      dispatch(setSettingUpService(false));
      return;
    }

    const rememberMe = localStorage.getItem("rememberMe");

    if (!loaders?.binanceConnecting) {
      dispatch(setLoading(false));
      dispatch(setResponseLoading(false));
    }
    dispatch(setSigningYouIn(false));
    dispatch(setSettingUpService(false));

    if (!persistedUser) {
      dispatch(setLoading(false));
    } else if (rememberMe) {
      dispatch(setLoading(true));
    }

    const token = localStorage.getItem("token");
    if (rememberMe && token && persistedUser && !persistedUser.firstVisit) {
      const role = persistedUser.role;
      if (role === "leader") {
        window.location.href = "/leader/dashboard";
      } else if (role === "member") {
        window.location.href = "/member/dashboard";
      }
    }
  }, [
    dispatch,
    isOAuthCallback,
    loaders?.binanceConnecting,
    persistedUser,
  ]);

  const showOutlet =
    oauthBootstrapActive || !loaders.isLoading || isOAuthCallback;

  return (
    <>
      {loaders?.isLoading && !oauthBootstrapActive && <LoadingModal />}
      {loaders?.settingUpService && (
        <AuthLoader component="settings" user={persistedUser} />
      )}
      {loaders?.signingYouIn && <AuthLoader />}
      {oauthBootstrapActive && (
        <div className="wrapper">
          <div className="text-center p-5">Connecting exchange…</div>
        </div>
      )}
      {showOutlet && !oauthBootstrapActive && (
        <div className="wrapper">
          <div>
            <Outlet />
            <ScrollRestoration />
          </div>
        </div>
      )}
    </>
  );
};
